import axios from 'axios';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL || '';
export const API = `${BACKEND_URL}/api`;

export const api = axios.create({
  baseURL: API,
  headers: { 'Content-Type': 'application/json' },
});

api.interceptors.request.use((config) => {
  const token = localStorage.getItem('indusfact_token');
  if (token) {
    config.headers.Authorization = `Bearer ${token}`;
  }
  return config;
});

api.interceptors.response.use(
  (r) => r,
  (error) => {
    if (error?.response?.status === 401) {
      // Token expired/invalid
      // do not auto-redirect from api layer; let UI decide
    }
    return Promise.reject(error);
  }
);

export const mediaUrl = (path) => {
  if (!path) return '';
  if (path.startsWith('http://') || path.startsWith('https://')) return path;
  return `${BACKEND_URL}${path}`;
};

export const uploadFile = async (file, kind = 'image', options = {}) => {
  const form = new FormData();
  form.append('file', file);
  const endpoint =
    kind === 'video' ? '/media/upload/video' :
    kind === 'pdf' ? '/media/upload/pdf' :
    '/media/upload/image';
  // The IndusFact watermark is applied purely by upload PURPOSE (context).
  // Only `context: 'listing_photo'` is watermarked; everything else (default
  // 'general', plus location_hero / category_image / blog_image / cms_image /
  // sponsored_ad_image / admin_upload / og_image …) is stored clean. Pass the
  // context that matches the upload; the backend is the single decision point.
  const params = {};
  if (kind === 'image') {
    if (options.context) params.context = options.context;
    // Legacy staff-only override (brand assets) — still honoured server-side.
    if (options.watermark === false) params.watermark = false;
  }
  const res = await api.post(endpoint, form, {
    headers: { 'Content-Type': 'multipart/form-data' },
    params,
  });
  return res.data;
};

export default api;

/**
 * Extract a human-friendly error message from an axios error / API response.
 * Handles the two common backend shapes:
 *   1. `{ detail: "some string" }`      — most endpoints (single line)
 *   2. `{ detail: { message, reasons, ... } }` — Phase 7C content-moderation
 *      responses. Prefers `.message`, falls back to first `.reasons[]` entry.
 * Falls back to the axios error message or a generic fallback string.
 */
export const extractApiError = (err, fallback = 'Something went wrong') => {
  const d = err?.response?.data?.detail;
  if (typeof d === 'string' && d.trim()) return d;
  if (d && typeof d === 'object') {
    if (typeof d.message === 'string' && d.message.trim()) return d.message;
    if (Array.isArray(d.reasons) && d.reasons.length) return d.reasons[0];
  }
  if (typeof err?.message === 'string' && err.message.trim()) return err.message;
  return fallback;
};
